import * as jsonpatch from "fast-json-patch";
// import { Workout, SessionCreateRequest, SessionSearchFilter, SessionSearchResponse, Session } from '@api/entities';
import { IWorkoutApiClients, WorkoutApiClients } from "./workout.api.client";
import { Session, SessionCreateRequest, SessionSearchFilter, SessionSearchResponse, SessionTitleUpdate, Workout } from "src/api/entities";

export interface IWorkoutApiService {
    create(workout: SessionCreateRequest): Promise<Workout>;
    getById(id: number): Promise<Workout>;
    rename(id: number, sessionTitleUpdate: SessionTitleUpdate): Promise<Workout>;
    archive(id: number, archive: boolean): Promise<Workout>;
    edit(oldWorkout: Workout, updatedWorkout: Workout): Promise<Workout>;
    search(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string | undefined },
        filter?: SessionSearchFilter
    ): Promise<SessionSearchResponse>;
    delete(id: number): Promise<{ [key: string]: boolean; }>
}

export class WorkoutApiService implements IWorkoutApiService {
    private static instance: WorkoutApiService;
    private api: IWorkoutApiClients;

    private constructor(basePath: string) {
        this.api = WorkoutApiClients.getInstance(basePath);
    }

    static getInstance(basePath: string) {
        if (WorkoutApiService.instance == null) {
            WorkoutApiService.instance = new WorkoutApiService(basePath);
        }
        return WorkoutApiService.instance;
    }

    async create(workout: SessionCreateRequest): Promise<Workout> {
        return (await this.api.workout.create5(workout)).data;
    }

    async getById(id: number): Promise<Workout> {
        return (await this.api.workout.get2(id)).data;
    }

    async rename(id: number, sessionTitleUpdate: SessionTitleUpdate): Promise<Session> {
        return (await this.api.workout.updateTitle(id, sessionTitleUpdate)).data;
    }

    async archive(id: number, archive: boolean): Promise<Session> {
        return (await this.api.workout.updateArchive(id, archive)).data;
    }

    async delete(id: number): Promise<{ [key: string]: boolean; }> {
        const response: { [key: string]: boolean; } = (await this.api.workout.delete4(id)).data
        return response
    }

    async edit(oldWorkout: Workout, updatedWorkout: Workout): Promise<Workout> {
        const requestPatch: any = jsonpatch.compare(oldWorkout, updatedWorkout);
        const workout: Workout = (
            await this.api.workout.patch2(oldWorkout.id!, requestPatch)
        ).data;
        return workout;
    }

    async search(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string },
        filter?: SessionSearchFilter
    ): Promise<SessionSearchResponse> {

        

        return (
            await this.api.workout.search4({
                page,
                size,
                query,
                sort,
                filter,
            })
        ).data;
    }
}
